// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38d7f946","455":"77a334b4","977":"23859038"}[chunkId] + ".chunk.js";
};